module.exports = __webpack_public_path__ + "static/media/screen.e896ac0f.png";